export default __webpack_public_path__ + "static/media/visa.852f070f.svg";